import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Box, BoxProps, Typography } from "@mui/material";
import { FC } from "react";
import { Button } from "../../Button";
import { InjectedFieldHintProps } from "../../HighOrderComponents/lib/type";
import { strings } from "@/src/shared/strings";

interface HintAreaProps extends InjectedFieldHintProps, BoxProps {}

export const HintArea: FC<HintAreaProps> = ({
    children,
    className,
    hintAreaDetailsButtonText = strings.common.more,
    hintAreaDetailsButton,
    onHintAreaDetailsButtonPressed,
    ...rest
}) => {
    return (
        <Box
            className={cn(
                "bg-[#009DDE0F] p-3 text-dark-gray rounded flex flex-col gap-3",
                className,
            )}
            aria-label={"Hint area"}
            {...rest}
        >
            <Typography component={"aside"}>{children}</Typography>
            {hintAreaDetailsButton && (
                <Button
                    variant={"text"}
                    className={
                        "text-base font-semibold text-blue justify-start p-0 m-0 w-fit min-w-0 min-h-0 bg-transparent"
                    }
                    onClick={onHintAreaDetailsButtonPressed}
                >
                    {hintAreaDetailsButtonText || strings.common.more}
                </Button>
            )}
        </Box>
    );
};
